import { BrowserOptions } from '@sentry/react';

export type ISentry = {
  dsn: string;
  maxBreadcrumbs: number;
  appName: string;
  tracesSampleRate: number;
} & BrowserOptions;

type ResTiming = {
  bufSize: number;
  clearResTimingOnBeaconSend: boolean;
};

type WebAppDynamics = {
  appKey: string;
  adrumExtUrlHttp: string;
  adrumExtUrlHttps: string;
  beaconUrlHttp: string;
  beaconUrlHttps: string;
  xd: {
    enable: boolean;
  };
  spa: {
    spa2: boolean;
  };
  resTiming: ResTiming;
  maxUrlLength: number;
  longStackTrace: boolean;
};

export enum ENVS {
  LOCAL = 'local',
  DEV = 'dev',
  QA = 'qa',
  STG = 'staging',
  PROD = 'prod',
}

export interface IDisabledFeatures {
  miniAppBuyOnlineJourney: boolean;
  bca?: boolean;
  merchantRoutingForBcaAndSelfServiceAndUseBrowserRouter?: boolean;
  captcha: boolean;
  optimiseFeesCall: boolean;
  cartV2: boolean;
  dpo: boolean;
  agentOtp: boolean;
  healthCheck?: boolean;
  oldPageRedirect: boolean;
  fixedVariableTiers: boolean;
  analytics: boolean;
  debugtagging: boolean;
  fixedFeesCheck: boolean;
  sovDashboard: boolean;
  creditVetting: boolean;
  passport: boolean;
  sentry: boolean;
  pagination: boolean;
  valueAddedServices: boolean;
  thirdParty: boolean;
  retailRevamp: boolean;
  imageJoin: boolean;
  deviceActivation: boolean;
  tapOnPhoneComingSoon: boolean;
  paymentRequest: boolean;
  updateBankingDetails: boolean;
  paymentMethodCode: boolean;
  updateTerminalDetails: boolean;
  redirectLegacyUrls: boolean;
  bcaTopUp: boolean;
  idOptimisation: boolean;
  idOptimisationIdNumberCheck: boolean;
  disableDAScanner: boolean;
  webAppDynamics: boolean;
  selfieOptimisation: boolean;
}
export interface IEnvironment {
  name: string;
  env: ENVS;
  uiHost: string;
  uiBase: string;
  apiHost: string;
  apiHostCloud: string;
  apiBase: string;
  tealium: string;
  captchaURL: string;
  captchaKey: string;
  chopchopName: string;
  kwikaName: string;
  orderManagementApiBaseURL: string;
  otpApiBaseURL: string;
  pipefyBaseURL: string;
  allowDevTools: boolean;
  privateBaseURL: string;
  disabledFeatures: IDisabledFeatures;
  sentry: ISentry;
  webAppDynamicsConfig: WebAppDynamics;
}
